import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "LoginRoot",
    component: () => import("@/views/login/Default.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/login/Default.vue"),
  },
  {
    path: "/login/divvyAdmin",
    name: "AdminLogin",
    component: () => import("@/views/login/Divvy.vue"),
  },
  {
    path: "/login/libertymutual",
    name: "Login-LibertyMutual",
    component: () => import("@/views/login/LibertyMutual.vue"),
  },
  {
    path: "/libertymutual",
    redirect: { name: "Login-LibertyMutual" },
  },
  {
    path: "/autologin",
    name: "AutoLogin",
    component: () => import("@/views/autologin/AutoLogin.vue"),
  },
  {
    path: "/home",
    name: "Home",
    component: () => import("@/views/home/Landing.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/shop",
    name: "Shop",
    component: () => import("@/views/shop/Shop.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/curated-items",
    name: "Curated Items",
    component: () => import("@/views/shop/CuratedItems.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/filter",
    name: "Filter",
    component: () => import("@/views/shop/ProductSidebar.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/services",
    name: "Services",
    component: () => import("@/views/shop/Services.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/shop/category/:categoryId(\\d+)",
    name: "Category",
    props: (route) => ({
      initialCurrentCategoryId: Number(route.params.categoryId),
      clearSearch: true,
    }),
    component: () => import("@/views/shop/Shop.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/shop/product/:productCategoryId(\\d+)/:productId(\\d+)",
    name: "Product",
    props: (route) => ({ productId: Number(route.params.productId), productCategoryId: Number(route.params.productCategoryId) }),
    component: () => import("@/views/shop/Product.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/shop/custom-item",
    name: "CustomItem",
    component: () => import("@/views/shop/CustomItem.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/shop/ticket-and-experiences",
    name: "TicketAndExperiences",
    component: () => import("@/views/shop/TicketAndExperiences.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/shop/travel-events",
    name: "TravelEvents",
    component: () => import("@/views/shop/TravelEvents.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  //added divvy admin route
  {
    path: "/divvyadmin",
    name: "divvyAdminDashboard",
    component: () => import("@/views/divvyadmin/divvyAdminDashboard.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/clients-account-statement-configuration",
    name: "clientAccountStatementConfiguration",
    component: () => import("@/views/divvyadmin/clientAccountStatementConfiguration.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/sass-fees",
    name: "divvyAdminSassFees",
    component: () => import("@/views/divvyadmin/sassFees/sassFees.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/nps-survey-history",
    name: "divvyAdminNpsSurveyHistory",
    component: () => import("@/views/divvyadmin/npsSurveyHistory.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/sales-tax-list",
    name: "divvyAdminSalesTaxList",
    component: () => import("@/views/divvyadmin/divvyAdminSalesTaxList.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/manage-users",
    name: "ManageUsers",
    component: () =>
      import("@/views/divvyadmin/security/users/ManageUsers.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/manage-users/create-user",
    name: "AddUsers",
    component: () => import("@/views/divvyadmin/security/users/AddUsers.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/manage-users/edit-user/:Id(\\d+)",
    name: "EditSystemUser",
    props: (route) => ({
      initialCurrentuserId: Number(route.params.Id),
    }),
    component: () => import("@/views/divvyadmin/security/users/EditUsers.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/add-product",
    name: "AddNewProduct",
    component: () =>
      import(
        "@/views/divvyadmin/productandsuppliers/addnewproduct/AddNewProduct.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/manage-products/edit-product/:Id(\\d+)",
    name: "EditProduct",
    props: (route) => ({
      initialProductId: Number(route.params.Id),
    }),
    component: () =>
      import(
        "@/views/divvyadmin/productandsuppliers/searcheditproduct/EditProduct.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/manage-products",
    name: "ManageProducts",
    component: () =>
      import(
        "@/views/divvyadmin/productandsuppliers/searcheditproduct/ManageProducts.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/manage-suppliers",
    name: "ManageSuppliers",
    component: () =>
      import(
        "@/views/divvyadmin/productandsuppliers/suppliers/ManageSuppliers.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/manage-suppliers/add-supplier",
    name: "AddSuppliers",
    component: () =>
      import(
        "@/views/divvyadmin/productandsuppliers/suppliers/AddSuppliers.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/manage-suppliers/edit-supplier/:Id(\\d+)",
    name: "EditSupplier",
    props: (route) => ({
      initialCurrentSupplierId: Number(route.params.Id),
    }),
    component: () =>
      import(
        "@/views/divvyadmin/productandsuppliers/suppliers/EditSupplier.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/client-management",
    name: "ManageClients",
    component: () =>
      import(
        "@/views/divvyadmin/userClientManagement/client/ManageClients.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/client-management/create-client",
    name: "CreateClient",
    component: () =>
      import("@/views/divvyadmin/userClientManagement/client/AddClient.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/client-management/edit-client/:Id(\\d+)",
    name: "EditClient",
    props: (route) => ({
      initialCurrentId: Number(route.params.Id),
    }),
    component: () =>
      import("@/views/divvyadmin/userClientManagement/client/EditClient.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/client-management/client-updated/:Id",
    name: "ClientUpdateScreen",
    component: () =>
      import(
        "@/views/divvyadmin/userClientManagement/client/ClientUpdateScreen.vue"
      ),
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/client-management/client-delete/:Id",
    name: "ClientDeleteScreen",
    component: () =>
      import(
        "@/views/divvyadmin/userClientManagement/client/ClientDeleteScreen.vue"
      ),
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/clone-client",
    name: "cloneClientScreen",
    component: () =>
      import(
        "@/views/divvyadmin/userClientManagement/client/cloneClient/cloneClient.vue"
      ),
    meta: {
      requiresAuth: true,
    },
    redirect: {
      name: "cloneClientForm",
    },
    children: [
      {
        path: "",
        name: "cloneClientForm",
        component: () =>
          import(
            "@/views/divvyadmin/userClientManagement/client/cloneClient/cloneClientForm.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/clone-client/result",
        name: "cloneClientResult",
        component: () =>
          import(
            "@/views/divvyadmin/userClientManagement/client/cloneClient/cloneClientResult.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/business-units",
    name: "BusinessUnits",
    component: () =>
      import(
        "@/views/divvyadmin/userClientManagement/BusinessUnits/BusinessUnits.vue"
      ),
    meta: {
      requiresAuth: true,
    },
    redirect: {
      name: "CustomerSelect",
    },
    children: [
      {
        path: "",
        name: "CustomerSelect",
        component: () =>
          import(
            "@/views/divvyadmin/userClientManagement/BusinessUnits/Customers.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/business-units/edit/:customerId(\\d+)/:masterClientId(\\d+)",
        props: (route) => ({
          customerId: Number(route.params.customerId),
          masterClientId: Number(route.params.masterClientId),
        }),
        name: "EditBusinessUnits",
        component: () =>
          import(
            "@/views/divvyadmin/userClientManagement/BusinessUnits/EditBusinessUnits.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/customers",
    name: "Customers",
    component: () =>
      import("@/views/divvyadmin/userClientManagement/Customers/Customers.vue"),
    meta: {
      requiresAuth: true,
    },
    redirect: {
      name: "CustomerList",
    },
    children: [
      {
        path: "",
        name: "CustomerList",
        component: () =>
          import(
            "@/views/divvyadmin/userClientManagement/Customers/CustomersList.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/divvy-users",
    name: "Users",
    component: () =>
      import("@/views/divvyadmin/userClientManagement/users/Users.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/divvy-users/add-user",
    name: "DivvyAdminUsersAddUser",
    component: () =>
      import("@/views/divvyadmin/userClientManagement/users/UsersAddUser.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/divvy-users/edit-user/:id",
    name: "DivvyAdminUsersEditUser",
    component: () =>
      import("@/views/divvyadmin/userClientManagement/users/UsersEditUser.vue"),
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/divvy-users/user-points/:id",
    name: "DivvyAdminUsersPointsUpdate",
    component: () =>
      import(
        "@/views/divvyadmin/userClientManagement/users/UsersPointUpdate.vue"
      ),
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/divvy-users/user-points-screen/:Name",
    name: "DivvyAdminUsersPointsScreen",
    component: () =>
      import(
        "@/views/divvyadmin/userClientManagement/users/UserPointChangeScreen.vue"
      ),
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/divvy-users/loginhere-user",
    name: "DivvyAdminUsersLoginUser",
    component: () =>
      import(
        "@/views/divvyadmin/userClientManagement/users/UsersLoginUser.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/divvy-users/report-user/:id",
    name: "DivvyAdminUsersReportUser",
    component: () =>
      import(
        "@/views/divvyadmin/userClientManagement/users/UsersReportUser.vue"
      ),
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/divvy-users/user-details-changed",
    name: "DivvyAdminUsersAddUpdScreen",
    props: (route) => ({
      Name: route.params.Name,
      action: route.params.action,
    }),
    component: () =>
      import(
        "@/views/divvyadmin/userClientManagement/users/UsersAddUpdScreen.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/divvy-users/userlockscreen/:id",
    name: "DivvyAdminUsersLockScreen",
    component: () =>
      import(
        "@/views/divvyadmin/userClientManagement/users/UsersLockUserScreen.vue"
      ),
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/divvyadmin/breakage-report",
    name: "DivvyAdminBreakageReport",
    component: () =>
      import("@/views/divvyadmin/account/BreakageReport.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/divvyadmin/security-roles",
    name: "DivvyAdminManageSecurityRoles",
    component: () =>
      import("@/views/divvyadmin/security/manageRoles/SecurityRoles.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/divvyadmin/create-security-roles",
    name: "DivvyAdminManageCreateSecurityRoles",
    component: () =>
      import("@/views/divvyadmin/security/manageRoles/CreateSecurityRole.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/divvyadmin/edit-security-roles/:id",
    name: "DivvyAdminManageEditSecurityRoles",
    component: () =>
      import("@/views/divvyadmin/security/manageRoles/EditSecurityRole.vue"),
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/divvyadmin/delete-security-roles",
    name: "DivvyAdminManageDeleteSecurityRoles",
    component: () =>
      import("@/views/divvyadmin/security/manageRoles/DeleteSecurityRole.vue"),
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/divvyadmin/edit-keys",
    name: "DivvyAdminManageEditKeysPage",
    component: () =>
      import("@/views/divvyadmin/security/manageRoles/EditKeysPage.vue"),
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/crmBatchProcess",
    name: "BatchProcess",
    component: () =>
      import("@/views/divvyadmin/crmTools/BatchProcess/BatchProcess.vue"),
    meta: {
      requiresAuth: true,
    },
    redirect: { name: "BatchProcessSavedSearch" },
    children: [
      {
        path: "/",
        name: "BatchProcessSavedSearch",
        component: () =>
          import(
            "@/views/divvyadmin/crmTools/BatchProcess/BatchProcessSavedSearch.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "viewBatch",
        name: "BatchProcessViewBatch",
        component: () =>
          import(
            "@/views/divvyadmin/crmTools/BatchProcess/BatchProcessViewBatch.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/crmShipments",
    name: "ShippingSearch",
    component: () =>
      import("@/views/divvyadmin/crmTools/ShippingSearch/ShippingSearch.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/customer-orders",
    name: "CustomerOrders",
    component: () =>
      import("@/views/divvyadmin/crmTools/CustomerOrders/CustomerOrders.vue"),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "/customer-orders/customer-orders-list",
        name: "CustomerOrdersResult",
        component: () =>
          import(
            "@/views/divvyadmin/crmTools/CustomerOrders/CustomerOrdersResult.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/order-details",
    name: "OrderDetails",
    component: () =>
      import(
        "@/views/divvyadmin/crmTools/CustomerOrders/OrderDetails/CustomerOrderDetail.vue"
      ),
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  // prefunding and invoices route
  {
    path: "/invoices-transactions",
    name: "InvoicesAndTransactions",
    component: () =>
      import(
        "@/views/divvyadmin/prefundingAndInvoicing/invoicesAndTransactions/InvoicesAndTransaction.vue"
      ),
    meta: {
      requiresAuth: true,
    },
    // route gaurd added
    // beforeEnter(to, from, next) {
    //   const res = JSON.parse(localStorage.getItem("sidebarSubModules")).some(
    //     ({ sub_module_action }) => sub_module_action === ""
    //   );
    //   if (res) {
    //     next();
    //   } else {
    //     console.log("unauthorized!");
    //     next("/404");
    //   }
    // },
    children: [
      // {
      //   path: "invoices-transactions",
      //   name: "InvoicesAndTransactions",
      //   component: () =>
      //     import(
      //       "@/views/divvyadmin/prefundingAndInvoicing/transactions/InvoicesAndTransaction.vue"
      //     ),
      //   meta: {
      //     requiresAuth: true,
      //   },
      // },
    ],
  },
  // prefunding and invoices route
  {
    path: "/prefunding",
    name: "Prefunding",
    component: () =>
      import(
        "@/views/divvyadmin/prefundingAndInvoicing/prefunding/Prefunding.vue"
      ),
    meta: {
      requiresAuth: true,
    },
    // route gaurd added
    // beforeEnter(to, from, next) {
    //   const res = JSON.parse(localStorage.getItem("sidebarSubModules")).some(
    //     ({ sub_module_action }) => sub_module_action === ""
    //   );
    //   if (res) {
    //     next();
    //   } else {
    //     console.log("unauthorized!");
    //     next("/404");
    //   }
    // },
    children: [
      // {
      //   path: "invoices-transactions",
      //   name: "InvoicesAndTransactions",
      //   component: () =>
      //     import(
      //       "@/views/divvyadmin/prefundingAndInvoicing/transactions/InvoicesAndTransaction.vue"
      //     ),
      //   meta: {
      //     requiresAuth: true,
      //   },
      // },
    ],
  },
  {
    path: "/payment",
    name: "Payment",
    component: () => import("@/views/payment/Payment.vue"),
    meta: {
      requiresAuth: true,
    },
    redirect: {
      name: "PaymentPortal",
    },
    // route gaurd added
    // beforeEnter(to, from, next) {
    //   const res = JSON.parse(localStorage.getItem("sidebarSubModules")).some(
    //     ({ sub_module_action }) => sub_module_action === ""
    //   );
    //   if (res) {
    //     next();
    //   } else {
    //     console.log("unauthorized!");
    //     next("/404");
    //   }
    // },
    children: [
      // {
      //   path: "/",
      //   name: "PaymentPage",
      //   component: () => import("@/views/payment/Payment.vue"),
      //   meta: {
      //     requiresAuth: true,
      //   },
      // },
      {
        path: "stripe",
        name: "PaymentPortal",
        component: () => import("@/views/payment/StripePayment.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "success",
        name: "PaymentSuccess",
        component: () => import("@/views/payment/Success.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "failure",
        name: "PaymentFailure",
        component: () => import("@/views/payment/Failure.vue"),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  // adding fax route for divvy admin order
  {
    path: "/fax",
    name: "faxComponent",
    component: () => import("@/components/faxComponent.vue"),
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/notes-manager",
    name: "NotesManager",
    component: () =>
      import(
        "@/views/divvyadmin/crmTools/CustomerOrders/OrderDetails/CurrentNotes/NotesManager.vue"
      ),
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/excluded-keywords",
    name: "ExcludedKeywords",
    component: () =>
      import(
        "@/views/divvyadmin/productandsuppliers/excludedKeywords/excludedKeywords.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/general",
    name: "General",
    component: () =>
      import("@/views/divvyadmin/utilities/general/generalComponent.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/general-lookup",
    name: "GeneralLookup",
    component: () =>
      import("@/views/divvyadmin/utilities/generalLookup/GeneralLookup.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/pre-login",
    name: "GeneralPreLogin",
    component: () =>
      import("@/views/divvyadmin/utilities/generalPreLogin/preLogin.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/categories",
    name: "Categories",
    component: () =>
      import(
        "@/views/divvyadmin/productandsuppliers/categories/Categories.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },

  // added admin route
  {
    path: "/admin",
    name: "AdminDashboard",
    component: () => import("@/views/admin/AdminDashboard.vue"),
    meta: {
      requiresAuth: true,
    },
  }, // added dashboard route

  {
    path: "/dashboard-general",
    name: "P4P",
    component: () =>
      import("@/views/admin/dashboards/P4PDashboard/P4PDashboard.vue"),
    meta: {
      requiresAuth: true,
    },
    // route gaurd added
    beforeEnter(to, from, next) {
      const res = JSON.parse(localStorage.getItem("sidebarSubModules")).some(
        ({ sub_module_action }) => sub_module_action === "P4P"
      );
      if (res) {
        next();
      } else {
        console.log("unauthorized!");
        next("/404");
      }
    },
  },
  {
    path: "/dashboardLoginAndOrders",
    name: "LoginAndOrdersReport",
    component: () =>
      import(
        "@/views/admin/dashboards/LoginAndOrdersDashboard/LoginAndOrdersDashboard.vue"
      ),
    meta: {
      requiresAuth: true,
    },
    // route gaurd added
    beforeEnter(to, from, next) {
      const res = JSON.parse(localStorage.getItem("sidebarSubModules")).some(
        ({ sub_module_action }) => sub_module_action === "LoginsOrders"
      );
      if (res) {
        next();
      } else {
        console.log("unauthorized!");
        next("/404");
      }
    },
  },
  {
    path: "/points-remaining",
    name: "PointsRemaining",
    component: () => import("@/views/admin/dashboard/PointsRemaining.vue"),
    meta: {
      requiresAuth: true,
    },
    // route gaurd added
    beforeEnter(to, from, next) {
      const res = JSON.parse(localStorage.getItem("sidebarSubModules")).some(
        ({ sub_module_action }) => sub_module_action === "PointsRemaining"
      );
      if (res) {
        next();
      } else {
        console.log("unauthorized!");
        next("/404");
      }
    },
  },
  // added reports route
  {
    path: "/logins-and-orders-report",
    name: "AdminLoginsAndOrdersReport",
    component: () =>
      import(
        "@/views/admin/reports/loginsAndOrdersReport/LoginsAndOrdersReport.vue"
      ),
    meta: {
      requiresAuth: true,
    },
    // route gaurd added
    beforeEnter(to, from, next) {
      const res = JSON.parse(localStorage.getItem("sidebarSubModules")).some(
        ({ sub_module_action }) => sub_module_action === "LoginsOrdersReport"
      );
      if (res) {
        next();
      } else {
        console.log("unauthorized!");
        next("/404");
      }
    },
  },
  {
    path: "/logins-and-orders-report/logins-report-view",
    name: "AdminLoginsReportView",
    component: () =>
      import(
        "@/views/admin/reports/loginsAndOrdersReport/LoginsReportView.vue"
      ),
    meta: {
      requiresAuth: true,
    },
    // route gaurd added
    beforeEnter(to, from, next) {
      const res = JSON.parse(localStorage.getItem("sidebarSubModules")).some(
        ({ sub_module_action }) => sub_module_action === "LoginsOrdersReport"
      );
      if (res) {
        next();
      } else {
        console.log("unauthorized!");
        next("/404");
      }
    },
  },
  {
    path: "/logins-and-orders-report/orders-report-view",
    name: "AdminOrdersReportView",
    component: () =>
      import("@/views/admin/reports/loginsAndOrdersReport/OrderReportView.vue"),
    meta: {
      requiresAuth: true,
    },
    // route gaurd added
    beforeEnter(to, from, next) {
      const res = JSON.parse(localStorage.getItem("sidebarSubModules")).some(
        ({ sub_module_action }) => sub_module_action === "LoginsOrdersReport"
      );
      if (res) {
        next();
      } else {
        console.log("unauthorized!");
        next("/404");
      }
    },
  },
  {
    path: "/funding-dashboard",
    name:"FundingDashboard",
    component: () => import("@/views/admin/funding/FundingDashboard/FundingDashboard.vue"),
    beforeEnter(to, from, next) {
      const res = JSON.parse(localStorage.getItem("sidebarSubModules")).some(
        ({ sub_module_action }) => sub_module_action === "FundingDashboard"
      );
      if (res) {
        next();
      } else {
        console.log("unauthorized!");
        next("/404");
      }
    },

  },
  {
    path: "/funding-result",
    name:"FundingSetupResult",
    component: () => import("@/views/admin/funding/FundingDashboard/FundingSetupResult.vue")

  },
  {
    path: "/payment-methods",
    name:"PaymentMethods",
    component: () => import("@/views/admin/funding/FundingDashboard/PaymentMethods.vue"),
    beforeEnter(to, from, next) {
      const res = JSON.parse(localStorage.getItem("sidebarSubModules")).some(
        ({ sub_module_action }) => sub_module_action === "PaymentMethods"
      );
      if (res) {
        next();
      } else {
        console.log("unauthorized!");
        next("/404");
      }
    },

  },
  {
    path: "/transaction-report",
    name: "AdminTransactionReport",
    component: () =>
      import("@/views/admin/reports/transactionReport/TransactionReport.vue"),
    meta: {
      requiresAuth: true,
    },
    // route gaurd added
    beforeEnter(to, from, next) {
      const res = JSON.parse(localStorage.getItem("sidebarSubModules")).some(
        ({ sub_module_action }) => sub_module_action === "TransactionReport"
      );
      if (res) {
        next();
      } else {
        console.log("unauthorized!");
        next("/404");
      }
    },
  },
  {
    path: "/transaction-report/transaction-report-view",
    name: "AdminTransactionReportView",
    component: () =>
      import(
        "@/views/admin/reports/transactionReport/TransactionReportView.vue"
      ),
    meta: {
      requiresAuth: true,
    },
    // route gaurd added
    beforeEnter(to, from, next) {
      const res = JSON.parse(localStorage.getItem("sidebarSubModules")).some(
        ({ sub_module_action }) => sub_module_action === "TransactionReport"
      );
      if (res) {
        next();
      } else {
        console.log("unauthorized!");
        next("/404");
      }
    },
  },
  {
    path: "/transaction-report/transaction-report-view/:Id(\\d+)",
    name: "AdminTransactionRecordDetail",
    props: (route) => ({
      initialCurrentSupplierId: Number(route.params.Id),
    }),
    component: () =>
      import(
        "@/views/admin/reports/transactionReport/TransactionRecordDetail.vue"
      ),
    meta: {
      requiresAuth: true,
    },
    // route gaurd added
    beforeEnter(to, from, next) {
      const res = JSON.parse(localStorage.getItem("sidebarSubModules")).some(
        ({ sub_module_action }) => sub_module_action === "TransactionReport"
      );
      if (res) {
        next();
      } else {
        console.log("unauthorized!");
        next("/404");
      }
    },
  },
  {
    path: "/tax-report",
    name: "TaxReportingDatabase",
    component: () =>
      import(
        "@/views/admin/reports/taxReportingDatabase/TaxReportingDatabase.vue"
      ),
    meta: {
      requiresAuth: true,
    },
    // route gaurd added
    beforeEnter(to, from, next) {
      const res = JSON.parse(localStorage.getItem("sidebarSubModules")).some(
        ({ sub_module_action }) => sub_module_action === "TaxReportingDatabase"
      );
      if (res) {
        next();
      } else {
        console.log("unauthorized!");
        next("/404");
      }
    },
  },
  {
    path: "/excel-report",
    name: "GenerateExcelReport",
    component: () =>
      import(
        "@/views/admin/reports/generateExcelReport/GenerateExcelReport.vue"
      ),
    meta: {
      requiresAuth: true,
    },
    // route gaurd added
    beforeEnter(to, from, next) {
      const res = JSON.parse(localStorage.getItem("sidebarSubModules")).some(
        ({ sub_module_action }) => sub_module_action === "GenerateExcelReport"
      );
      if (res) {
        next();
      } else {
        console.log("unauthorized!");
        next("/404");
      }
    },
  },
  {
    path: "/excel-report-screen",
    name: "GenerateExcelReportScreen",
    component: () =>
      import(
        "@/views/admin/reports/generateExcelReport/DownloadReportScreen.vue"
      ),
    meta: {
      requiresAuth: true,
    },
    // route gaurd added
    beforeEnter(to, from, next) {
      const res = JSON.parse(localStorage.getItem("sidebarSubModules")).some(
        ({ sub_module_action }) => sub_module_action === "GenerateExcelReport"
      );
      if (res) {
        next();
      } else {
        console.log("unauthorized!");
        next("/404");
      }
    },
  },
  {
    path: "/taxation-report",
    name: "GenerateTaxationReport",
    component: () =>
      import(
        "@/views/admin/reports/generateTaxationReport/GenerateTaxationReport.vue"
      ),
    meta: {
      requiresAuth: true,
    },
    // route gaurd added
    beforeEnter(to, from, next) {
      const res = JSON.parse(localStorage.getItem("sidebarSubModules")).some(
        ({ sub_module_action }) =>
          sub_module_action === "GenerateLibertyTaxationReport"
      );
      if (res) {
        next();
      } else {
        console.log("unauthorized!");
        next("/404");
      }
    },
  },

  // added user manager route
  {
    path: "/user-manager",
    name: "AdminUserManager",
    component: () => import("@/views/admin/users/userManager/UserManager.vue"),
    meta: {
      requiresAuth: true,
    },
    // route gaurd added
    beforeEnter(to, from, next) {
      const res = JSON.parse(localStorage.getItem("sidebarSubModules")).some(
        ({ sub_module_action }) => sub_module_action === "UserManager"
      );
      if (res) {
        next();
      } else {
        console.log("unauthorized!");
        next("/404");
      }
    },
  },
  {
    path: "/user-manager",
    name: "AdminUserManagerMessage",
    props: (route) => ({
      userId: route.params.userId,
      action: route.params.action,
    }),
    component: () =>
      import("@/views/admin/users/userManager/UserManagerMessage.vue"),
    meta: {
      requiresAuth: true,
    },
    // route gaurd added
    beforeEnter(to, from, next) {
      const res = JSON.parse(localStorage.getItem("sidebarSubModules")).some(
        ({ sub_module_action }) => sub_module_action === "UserManager"
      );
      if (res) {
        next();
      } else {
        console.log("unauthorized!");
        next("/404");
      }
    },
  },
  {
    path: "/user-manager/lock-edit-confirm",
    name: "LockEditConfirm",
    props :(route) => ({
      userId : route.params.userId,
      newLockedState: route.params.newLockedState,
      username: route.params.username,
      fullName: route.params.fullName
    }),
    component: () => import("@/views/admin/users/userManager/LockEditConfirm.vue"),
    meta: {
      requiresAuth: true,
    },
    // route gaurd added
    beforeEnter(to, from, next) {
      const res = JSON.parse(localStorage.getItem("sidebarSubModules")).some(
        ({ sub_module_action }) => sub_module_action === "UserManager"
      );
      if (res) {
        next();
      } else {
        console.log("unauthorized!");
        next("/404");
      }
    },
  },
  // added user manager add user route
  {
    path: "/user-manager/add-user",
    name: "AdminUserManagerAddUser",
    component: () =>
      import("@/views/admin/users/userManager/UserManagerAddUser.vue"),
    meta: {
      requiresAuth: true,
    },
    // route gaurd added
    beforeEnter(to, from, next) {
      const res = JSON.parse(localStorage.getItem("sidebarSubModules")).some(
        ({ sub_module_action }) => sub_module_action === "UserManager"
      );
      if (res) {
        next();
      } else {
        console.log("unauthorized!");
        next("/404");
      }
    },
  },
  // added user manager edit user by id route
  {
    path: "/user-manager/edit-user/:userId(\\d+)",
    props: (route) => ({ userId: Number(route.params.userId) }),
    name: "AdminUserManagerEditUser",
    component: () =>
      import("@/views/admin/users/userManager/UserManagerEditUser.vue"),
    meta: {
      requiresAuth: true,
    },
    // route gaurd added
    beforeEnter(to, from, next) {
      const res = JSON.parse(localStorage.getItem("sidebarSubModules")).some(
        ({ sub_module_action }) => sub_module_action === "UserManager"
      );
      if (res) {
        next();
      } else {
        console.log("unauthorized!");
        next("/404");
      }
    },
  },
  // added user manager points route
  {
    path: "/user-manager/points/:userId(\\d+)",
    props: (route) => ({ userId: Number(route.params.userId) }),
    name: "AdminUserManagerPoints",
    component: () =>
      import("@/views/admin/users/userManager/UserManagerPoints.vue"),
    meta: {
      requiresAuth: true,
    },
    // route gaurd added
    beforeEnter(to, from, next) {
      const res = JSON.parse(localStorage.getItem("sidebarSubModules")).some(
        ({ sub_module_action }) => sub_module_action === "UserManager"
      );
      if (res) {
        next();
      } else {
        console.log("unauthorized!");
        next("/404");
      }
    },
  },
  // added user manager transaction report route
  {
    path: "/user-transaction-report/:userId(\\d+)",
    props: (route) => ({ userId: Number(route.params.userId) }),
    name: "AdminUserManagerTransactionReport",
    component: () =>
      import("@/views/admin/users/userManager/TransactionReport.vue"),
    meta: {
      requiresAuth: true,
    },
    // route gaurd added
    beforeEnter(to, from, next) {
      const res = JSON.parse(localStorage.getItem("sidebarSubModules")).some(
        ({ sub_module_action }) => sub_module_action === "UserManager"
      );
      if (res) {
        next();
      } else {
        console.log("unauthorized!");
        next("/404");
      }
    },
  },
  // added total points route
  {
    path: "/total-points",
    name: "AdminUsersTotalPoints",
    component: () => import("@/views/admin/users/totalPoints/TotalPoints.vue"),
    meta: {
      requiresAuth: true,
    },
    // route gaurd added
    beforeEnter(to, from, next) {
      const res = JSON.parse(localStorage.getItem("sidebarSubModules")).some(
        ({ sub_module_action }) => sub_module_action === "TotalPoints"
      );
      if (res) {
        next();
      } else {
        console.log("unauthorized!");
        next("/404");
      }
    },
  },
  {
    path: "/users-update",
    name: "UsersUpdate",
    component: () => import("@/views/admin/users/usersUpdate/UsersUpdate.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  // added batch user upload tool
  {
    path: "/batch-user-upload-tool",
    name: "AdminBatchUserUploadToolMain",
    component: () =>
      import(
        "@/views/admin/users/batchUserUploadTool/BatchUserUploadToolMain.vue"
      ),
    meta: {
      requiresAuth: true,
    },
    redirect: {
      name: "AdminBatchUserUploadTool",
    },
    // route gaurd added
    beforeEnter(to, from, next) {
      const res = JSON.parse(localStorage.getItem("sidebarSubModules")).some(
        ({ sub_module_action }) => sub_module_action === "BatchUserUploadTool"
      );
      if (res) {
        next();
      } else {
        console.log("unauthorized!");
        next("/404");
      }
    },
    children: [
      {
        path: "/",
        name: "AdminBatchUserUploadTool",
        component: () =>
          import(
            "@/views/admin/users/batchUserUploadTool/BatchUserUploadTool.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "preview-insert-users",
        name: "AdminBatchUserUploadToolPreviewInsertUsers",
        props: true,
        component: () =>
          import(
            "@/views/admin/users/batchUserUploadTool/BatchUserUploadToolPreviewInsertUsers.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "edit/:uploadId(\\d+)",
        props: (route) => ({
          uploadId: route.params.uploadId,
          operationType: route.params.operationType,
          previousRoute: route.params.previousRoute,
          activeMenuItem: route.params.activeMenuItem
        }),
        name: "AdminBatchUserUploadToolPreviewInsertUsersEdit",
        component: () =>
          import(
            "@/views/admin/users/batchUserUploadTool/BatchUserUploadToolEditPreviewInsertUsers.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "edit-records",
        name: "AdminBatchUserUploadToolEditRecords",
        props: true,
        component: () =>
          import(
            "@/views/admin/users/batchUserUploadTool/BatchUserUploadToolEditRecords.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "preview-update-information",
        name: "AdminBatchUserUploadToolUpdateInformation",
        props: true,
        component: () =>
          import(
            "@/views/admin/users/batchUserUploadTool/BatchUserUploadToolUpdateInformation.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "preview-points-information",
        name: "AdminBatchUserUploadToolUpdatePoints",
        props: true,
        component: () =>
          import(
            "@/views/admin/users/batchUserUploadTool/BatchUserUploadToolUpdatePoints.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "preview-points-information",
        name: "AdminBatchUserUploadToolDeletePoints",
        props: true,
        component: () =>
          import(
            "@/views/admin/users/batchUserUploadTool/BatchUserUploadToolDeletePoints.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },

  // added batch user create tool
  {
    path: "/batch-user-create-tool",
    name: "AdminBatchUserCreateTool",
    component: () =>
      import("@/views/admin/users/batchUserCreateTool/BatchUserCreateTool.vue"),
    meta: {
      requiresAuth: true,
    },
    // route gaurd added
    beforeEnter(to, from, next) {
      const res = JSON.parse(localStorage.getItem("sidebarSubModules")).some(
        ({ sub_module_action }) => sub_module_action === "BatchUserCreateTool"
      );
      if (res) {
        next();
      } else {
        console.log("unauthorized!");
        next("/404");
      }
    },
  },
  // added batch point upload tool
  {
    path: "/batch-point-upload-tool",
    name: "AdminBatchPointUploadTool",
    component: () =>
      import(
        "@/views/admin/users/batchPointUploadTool/BatchPointUploadTool.vue"
      ),
    meta: {
      requiresAuth: true,
    },
    // route gaurd added
    beforeEnter(to, from, next) {
      const res = JSON.parse(localStorage.getItem("sidebarSubModules")).some(
        ({ sub_module_action }) => sub_module_action === "BatchPointUploadTool"
      );
      if (res) {
        next();
      } else {
        console.log("unauthorized!");
        next("/404");
      }
    },
  },
  // added send email to users route
  {
    path: "/send-email-to-users",
    name: "AdminSendEmailToUser",
    component: () =>
      import("@/views/admin/users/sendEmailToUsers/SendEmailToUsers.vue"),
    meta: {
      requiresAuth: true,
    },
    // route gaurd added
    beforeEnter(to, from, next) {
      const res = JSON.parse(localStorage.getItem("sidebarSubModules")).some(
        ({ sub_module_action }) => sub_module_action === "SendEmailtoUsers"
      );
      if (res) {
        next();
      } else {
        console.log("unauthorized!");
        next("/404");
      }
    },
  },
  {
    path: "/admin-points-faq",
    name: "AdminPointsFaq",
    component: () => import("@/views/admin/faq/Faq.vue"),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "/admin-points-faq/access-compact",
        name: "AccessCompact",
        component: () => import("@/views/admin/faq/AccessCompact.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin-points-faq/blank-template",
        name: "BlankTemplate",
        component: () => import("@/views/admin/faq/BlankTemplate.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin-points-faq/change-password",
        name: "ChangePassword",
        component: () => import("@/views/admin/faq/ChangePassword.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin-points-faq/column",
        name: "Column",
        component: () => import("@/views/admin/faq/Column.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin-points-faq/create",
        name: "Create",
        component: () => import("@/views/admin/faq/Create.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin-points-faq/co-matrix",
        name: "COMatrix",
        component: () => import("@/views/admin/faq/COMatrix.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin-points-faq/delete",
        name: "Delete",
        component: () => import("@/views/admin/faq/Delete.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin-points-faq/large-files",
        name: "LargeFiles",
        component: () => import("@/views/admin/faq/LargeFiles.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin-points-faq/previous-files",
        name: "PreviousFiles",
        component: () => import("@/views/admin/faq/PreviousFiles.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin-points-faq/upload",
        name: "Upload",
        component: () => import("@/views/admin/faq/Upload.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin-points-faq/summary",
        name: "Summary",
        component: () => import("@/views/admin/faq/Summary.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin-points-faq/program",
        name: "Program",
        component: () => import("@/views/admin/faq/Program.vue"),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  // added add points route
  {
    path: "/add-points",
    name: "AdminAddPoints",
    component: () => import("@/views/admin/users/addPoints/AddPoints.vue"),
    meta: {
      requiresAuth: true,
    },
    redirect: {
      name: "AdminAddPointsSelectPrograms",
    },
    // route gaurd added
    beforeEnter(to, from, next) {
      const res = JSON.parse(localStorage.getItem("sidebarSubModules")).some(
        ({ sub_module_action }) => sub_module_action === "AddPoints"
      );
      if (res) {
        next();
      } else {
        console.log("unauthorized!");
        next("/404");
      }
    },
    children: [
      {
        path: "",
        name: "AdminAddPointsSelectPrograms",
        component: () =>
          import("@/views/admin/users/addPoints/AddPointsSelectPrograms.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "add-points/groups/:programId",
        name: "AdminAddPointsChooseGroupLocation",
        component: () =>
          import(
            "@/views/admin/users/addPoints/AddPointsChooseGroupLocation.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "add-points/build/:programId/:clientId",
        name: "AdminAddPointsBuildListOfUsers",
        props: true,
        component: () =>
          import("@/views/admin/users/addPoints/AddPointsBuildListOfUsers.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "add-points/finalize/:programId/:clientId",
        name: "AdminAddPointsFinalizeListOfUsers",
        component: () =>
          import(
            "@/views/admin/users/addPoints/AddPointsFinalizeListOfUsers.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "add-points/set-points/:programId/:clientId",
        props: (route) => ({
          programId: route.params.programId,
          clientId: route.params.clientId,
        }),
        name: "AdminAddPointsSetPoints",
        component: () =>
          import("@/views/admin/users/addPoints/AddPointsSetPoints.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "add-points/pointsMessaage/:pointsAdded",
        props: (route) => ({ pointsAdded: route.params.pointsAdded }),
        name: "AdminAddPointsSystemMessage",
        component: () =>
          import("@/views/admin/users/addPoints/AddPointsSystemMessage.vue"),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/bulletin/:bulletinId(\\d+)",
    props: (route) => ({ bulletinId: Number(route.params.bulletinId) }),
    name: "EditBulletin",
    component: () =>
      import("@/views/admin/commmunication/bulletin/EditBulletin.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/bulletin/add",
    props: (route) => ({ bulletinId: Number(route.params.bulletinId) }),
    name: "AddBulletin",
    component: () =>
      import("@/views/admin/commmunication/bulletin/AddBulletin.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/bulletin",
    name: "Bulletin",
    component: () =>
      import("@/views/admin/commmunication/bulletin/Bulletin.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/client-blogs",
    name: "ClientBlogs",
    component: () =>
      import("@/views/admin/commmunication/client/ClientBlogs.vue"),
    meta: {
      requiresAuth: true,
    },
    // route gaurd added
    beforeEnter(to, from, next) {
      const res = JSON.parse(localStorage.getItem("sidebarSubModules")).some(
        ({ sub_module_action }) => sub_module_action === "ClientBlogs"
      );
      if (res) {
        next();
      } else {
        console.log("unauthorized!");
        next("/404");
      }
    },
  },
  {
    path: "/order-approval",
    name: "OrderApproval",
    component: () =>
      import("@/views/admin/orders/OrderApproval.vue"),
    meta: {
      requiresAuth: true,
    },
    // route gaurd added
    beforeEnter(to, from, next) {
      const res = JSON.parse(localStorage.getItem("sidebarSubModules")).some(
        ({ sub_module_action }) => sub_module_action === "OrderApproval"
      );
      if (res) {
        next();
      } else {
        console.log("unauthorized!");
        next("/404");
      }
    },
  },
  // added points progarm route
  {
    path: "/point-programs",
    name: "AdminPointPrograms",
    component: () =>
      import("@/views/admin/users/pointPrograms/PointPrograms.vue"),
    meta: {
      requiresAuth: true,
    },
    redirect: {
      name: "AdminPointProgramsList",
    },
    // route gaurd added
    beforeEnter(to, from, next) {
      const res = JSON.parse(localStorage.getItem("sidebarSubModules")).some(
        ({ sub_module_action }) => sub_module_action === "PointPrograms"
      );
      if (res) {
        next();
      } else {
        console.log("unauthorized!");
        next("/404");
      }
    },
    children: [
      {
        path: "list",
        name: "AdminPointProgramsList",
        component: () =>
          import("@/views/admin/users/pointPrograms/PointProgramsList.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "add",
        name: "AdminPointProgramsNewProgramContest",
        component: () =>
          import(
            "@/views/admin/users/pointPrograms/PointProgramsNewProgramContest.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "edit/:programId(\\d+)",
        name: "AdminPointProgramsEditProgramContest",
        component: () =>
          import(
            "@/views/admin/users/pointPrograms/PointProgramsEditProgramContest.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "location-or-companies",
        name: "AdminPointProgramsEditClients",
        component: () =>
          import(
            "@/views/admin/users/pointPrograms/PointProgramsEditClients.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "location-or-companies",
        props: (route) => ({ clientData: route.params.clientData }),
        name: "AdminPointProgramsEditActivePrograms",
        component: () =>
          import(
            "@/views/admin/users/pointPrograms/PointProgramEditActivePrograms.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  // added settings module route
  {
    path: "/settings",
    name: "AdminSettingsRoleAndPermissions",
    component: () => import("@/views/admin/settings/RolesAndPermissions.vue"),
    meta: {
      requiresAuth: true,
    },
    redirect: {
      name: "AdminSettingsRoleAndPermissionsList",
    },
    children: [
      {
        path: "/",
        name: "AdminSettingsRoleAndPermissionsList",
        component: () =>
          import("@/views/admin/settings/RoleAndPermissionsList.vue"),
        meta: {
          requiresAuth: true,
        },
        // route gaurd added
        beforeEnter(to, from, next) {
          const res = JSON.parse(
            localStorage.getItem("sidebarSubModules")
          ).some(
            ({ sub_module_action }) =>
              sub_module_action === "RolesandPermissions"
          );
          if (res) {
            next();
          } else {
            console.log("unauthorized!");
            next("/404");
          }
        },
      },
      {
        path: "/add-role",
        name: "AdminSettingsRoleAndPermissionsAdd",
        component: () =>
          import("@/views/admin/settings/RoleAndPermissionsAdd.vue"),
        meta: {
          requiresAuth: true,
        },
        // route gaurd added
        beforeEnter(to, from, next) {
          const res = JSON.parse(
            localStorage.getItem("sidebarSubModules")
          ).some(
            ({ sub_module_action }) =>
              sub_module_action === "RolesandPermissions"
          );
          if (res) {
            next();
          } else {
            console.log("unauthorized!");
            next("/404");
          }
        },
      },
      {
        path: "/edit-role/:clientRoleId(\\d+)",
        name: "AdminSettingsRoleAndPermissionsEdit",
        component: () =>
          import("@/views/admin/settings/RoleAndPermissionsEdit.vue"),
        meta: {
          requiresAuth: true,
        },
        // route gaurd added
        beforeEnter(to, from, next) {
          const res = JSON.parse(
            localStorage.getItem("sidebarSubModules")
          ).some(
            ({ sub_module_action }) =>
              sub_module_action === "RolesandPermissions"
          );
          if (res) {
            next();
          } else {
            console.log("unauthorized!");
            next("/404");
          }
        },
      },
      {
        path: "/modules",
        name: "AdminSettingsModules",
        component: () => import("@/views/admin/settings/ModulesComponent.vue"),
        meta: {
          requiresAuth: true,
        },
        // route gaurd added
        beforeEnter(to, from, next) {
          const res = JSON.parse(
            localStorage.getItem("sidebarSubModules")
          ).some(({ sub_module_action }) => sub_module_action === "Modules");
          if (res) {
            next();
          } else {
            console.log("unauthorized!");
            next("/404");
          }
        },
      },
      {
        path: "manage-roles",
        name: "AdminSettingsRoleAndPermissionsManageRoles",
        component: () => import("@/views/admin/settings/ManageUserRoles.vue"),
        meta: {
          requiresAuth: true,
        },
        // route gaurd added
        beforeEnter(to, from, next) {
          const res = JSON.parse(
            localStorage.getItem("sidebarSubModules")
          ).some(
            ({ sub_module_action }) =>
              sub_module_action === "RolesandPermissions"
          );
          if (res) {
            next();
          } else {
            console.log("unauthorized!");
            next("/404");
          }
        },
      },
      {
        path: "assign-roles",
        name: "AdminSettingsRoleAndPermissionsAssignRoles",
        component: () => import("@/views/admin/settings/AssignUserRoles.vue"),
        meta: {
          requiresAuth: true,
        },
        // route gaurd added
        beforeEnter(to, from, next) {
          const res = JSON.parse(
            localStorage.getItem("sidebarSubModules")
          ).some(
            ({ sub_module_action }) =>
              sub_module_action === "RolesandPermissions"
          );
          if (res) {
            next();
          } else {
            console.log("unauthorized!");
            next("/404");
          }
        },
      },
    ],
  },
  {
    path: "/history",
    name: "AccountHistory",
    component: () => import("@/views/userAccount/AccountHistory.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/account",
    name: "AccountInformation",
    component: () => import("@/views/userAccount/AccountInformation.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/orders",
    name: "OrderTracking",
    component: () => import("@/views/userAccount/OrderTracking.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/program",
    name: "Program",
    component: () => import("@/views/program/Program.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/program",
    name: "ProgramMenu",
    component: () => import("@/views/program/Program.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/bonus",
    name: "Bonus Points",
    component: () => import("@/views/bonus/Bonus.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/bonus/product/:productId(\\d+)",
    name: "Bonus Product",
    props: (route) => ({ productId: Number(route.params.productId) }),
    component: () => import("@/views/bonus/Product.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/bonus/checkout/shipping",
    name: "Bonus Checkout",
    component: () => import("@/views/bonus/checkout/ShippingInfo.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/bonus/checkout/summary",
    name: "Bonus Order Summary",
    component: () => import("@/views/bonus/checkout/OrderSummary.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wishlist",
    name: "Wishlist",
    component: () => import("@/views/wishlist/Wishlist.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cart",
    name: "Cart",
    component: () => import("@/views/cart/Cart.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/checkout/shipping",
    name: "Checkout",
    component: () => import("@/views/checkout/ShippingInfo.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/checkout/summary",
    name: "Order Summary",
    component: () => import("@/views/checkout/OrderSummary.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "*",
    name: "404",
    component: () => import("@/components/Error404.vue"),
  },
];

const router = new VueRouter({
  routes,
  mode: "history",
});

router.beforeEach((to, from, next) => {
  if (
    to.matched.some((record) => record.meta.requiresAuth) &&
    !store.getters["auth/isAuthenticated"]
  ) {
    next("/");
  } else {
    next();
  }
});

export default router;
